var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/index.ts
export * from "react-router-dom";

// src/routes.tsx
import React from "react";
import { Routes as RoutesBase } from "react-router-dom";
import { withSentryReactRouterV6Routing } from "@sentry/react";
var WrappedRoutes;
var Routes = (props) => {
  if (!WrappedRoutes) {
    WrappedRoutes = withSentryReactRouterV6Routing(RoutesBase);
  }
  return /* @__PURE__ */ React.createElement(WrappedRoutes, __spreadValues({}, props));
};

// src/use-params-legacy.hook.ts
import { useParams } from "react-router-dom";
var useParamsLegacy = useParams;

// src/link-legacy.tsx
import React2, { forwardRef, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";

// src/utils.ts
var doRestoreV5RelativeTo = (path, currentPathName) => (
  // If `path` is absolute...
  path.startsWith("/") || // ...or it's just a hash...
  path.startsWith("#") || // or the current URL ends with a slash...
  currentPathName.endsWith("/") ? (
    // then `path` can remain as-is to remain consistent with v5 behavior.
    path
  ) : (
    // otherwise, it needs to be prefixed with `../` to reproduce v5 behavior.
    `../${path}`
  )
);
var restoreV5RelativeTo = (to, currentPathname) => {
  if (!to) {
    return to;
  }
  let absoluteTo = to;
  if (typeof absoluteTo === "string") {
    absoluteTo = doRestoreV5RelativeTo(absoluteTo, currentPathname);
  } else if (typeof absoluteTo.pathname === "string") {
    absoluteTo.pathname = doRestoreV5RelativeTo(
      absoluteTo.pathname,
      currentPathname
    );
  }
  return absoluteTo;
};

// src/link-legacy.tsx
var LinkLegacy = forwardRef(
  (_a, ref) => {
    var _b = _a, { to: maybeFunctionTo, onClick } = _b, rest = __objRest(_b, ["to", "onClick"]);
    var _a2;
    const to = typeof maybeFunctionTo === "function" ? maybeFunctionTo() : maybeFunctionTo;
    let { state } = rest;
    let actualTo;
    if (typeof to === "object" && "state" in to) {
      _a2 = to, { state } = _a2, actualTo = __objRest(_a2, ["state"]);
    } else {
      actualTo = to;
    }
    const onClickWithPreventDefault = useCallback(
      (event) => {
        event.preventDefault();
        onClick(event);
      },
      [onClick]
    );
    const resolvedOnClick = onClick && !to ? onClickWithPreventDefault : onClick;
    const { pathname } = useLocation();
    return /* @__PURE__ */ React2.createElement(
      Link,
      __spreadProps(__spreadValues({
        relative: "path",
        ref,
        to: restoreV5RelativeTo(actualTo, pathname),
        onClick: resolvedOnClick
      }, rest), {
        state
      })
    );
  }
);

// src/navigate-legacy.tsx
import React3 from "react";
import { Navigate, useLocation as useLocation2 } from "react-router-dom";
var NavigateLegacy = (_a) => {
  var _b = _a, {
    to
  } = _b, rest = __objRest(_b, [
    "to"
  ]);
  const { pathname } = useLocation2();
  return /* @__PURE__ */ React3.createElement(
    Navigate,
    __spreadValues({
      relative: "path",
      to: restoreV5RelativeTo(to, pathname)
    }, rest)
  );
};

// src/use-navigate-legacy.hook.ts
import {
  useLocation as useLocation3,
  useNavigate
} from "react-router-dom";
var useNavigateLegacy = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation3();
  const ourNavigate = (to, options) => {
    if (typeof to === "number") {
      navigate(to);
    } else {
      navigate(restoreV5RelativeTo(to, pathname), __spreadValues({
        relative: "path"
      }, options));
    }
  };
  return ourNavigate;
};

// src/use-query-params.hook.ts
import React4 from "react";
import { useLocation as useLocation4 } from "react-router-dom";
var useQueryParams = () => {
  const { search } = useLocation4();
  return React4.useMemo(() => new URLSearchParams(search), [search]);
};

// src/use-location-legacy.hook.ts
import { useLocation as useLocation5 } from "react-router-dom";
var useLocationLegacy = useLocation5;

// src/use-nested-absolute-route.hook.tsx
import React5 from "react";
import { Route, useMatch } from "react-router-dom";
var useNestedAbsoluteRoute = ({
  base,
  path,
  element,
  condition = true
}) => {
  const match = useMatch({ path: base, end: false });
  if (condition && match) {
    return /* @__PURE__ */ React5.createElement(Route, { path, element });
  }
  return null;
};
export {
  LinkLegacy,
  NavigateLegacy,
  Routes,
  useLocationLegacy,
  useNavigateLegacy,
  useNestedAbsoluteRoute,
  useParamsLegacy,
  useQueryParams
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/routing'] = window.leagueSDKsPresent['@leagueplatform/routing'] || [];
    window.leagueSDKsPresent['@leagueplatform/routing'].push('2.27.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/routing'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/routing module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map